import React from "react";
import data from "../json/Allproducts/Xpertxpress.json";
import Section1 from "../components/Allproducts/Section1";
import Section5 from "../components/Allproducts/Section5";
import Article from "../components/Allproducts/ArticleSection";
import Features from "../components/Allproducts/FeaturesSection";


const XpertXpress = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data} />
      <Features data={data.features} />
      <Article data={data.article} />
      <Section5 data={data.services} />
    </div>
  );
};

export default XpertXpress;
